import { render, staticRenderFns } from "./LateArrivingHome.vue?vue&type=template&id=873440aa&"
import script from "./LateArrivingHome.vue?vue&type=script&lang=js&"
export * from "./LateArrivingHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports